// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"3220":"c4d7bd9d","5634":"692ffdca","8194":"f155fe87","8233":"46528522"}[chunkId] || chunkId) + "." + {"3220":"29483bfe07cd1343","5156":"70f55208fcf67e27","5634":"af56c93c23a38f1f","5810":"9ff98d103f4b9293","8194":"168c7fc15e624f49","8233":"934c086fca14c27f"}[chunkId] + ".js";
};